// extracted by mini-css-extract-plugin
export var closeButton = "_t-1";
export var container = "_t-0";
export var fullModalImage = "_t-2";